{
    "Profile_CommonComponents_Recap.taxesIncluded": "{estimatedAnnualGross} per year (taxes included)",
    "Profile_CommonComponents_Recap.savings": "Or {estimatedMonthlyGross} per month",
    "Profile_CommonComponents_Recap.downloadBinder": "Download Binder"
}
